exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mint-steps{overflow:hidden;padding-left:20px}.mint-steps--horizontal .mint-steps__items{display:-ms-flexbox;display:flex;margin:16px 10px 10px 0;overflow:hidden;position:relative;padding-bottom:32px}.mint-steps--horizontal .mint-steps__items.mint-steps__items--alone{padding-top:10px}.mint-steps__status{border-bottom-width:1px;border-bottom-style:solid}.mint-steps__icon{float:left;margin-right:10px}.mint-steps .mint-icon{font-size:23px;line-height:1}.mint-steps__message{display:table;height:49px}.mint-steps__message .mint-steps__message-wrapper{display:table-cell;vertical-align:middle}.mint-steps__title{font-size:17px}.mint-steps__desc{font-size:12px;line-height:1.5;max-height:18px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/bh-mint-ui2/lib/steps/style.css
// module id = 150
// module chunks = 0